import { render } from "./TablaCursosInscripciones.vue?vue&type=template&id=a6e498a8&ts=true"
import script from "./TablaCursosInscripciones.vue?vue&type=script&lang=ts"
export * from "./TablaCursosInscripciones.vue?vue&type=script&lang=ts"

import "./TablaCursosInscripciones.vue?vue&type=style&index=0&id=a6e498a8&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__